import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

import Modal from '../../molecules/modal';
import { useInternalDashboardSelector } from './Selector';
import Button from '../../atom/button';

export const StyledModal = styled(Modal)({
  zIndex: 9999,

  '& .MuiDialog-paper': {
    maxWidth: '1000px',
    borderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
  },
});

export const ModalErrorMessage = () => {
  const { selectedRow, stopRowAction, isShowErrorMessage } = useInternalDashboardSelector();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isJson, setIsJson] = useState<boolean>(false);
  useEffect(() => {
    const parseErrorMessage = () => {
      if (selectedRow?.invoiceFileProcessingMessage) {
        try {
          const msg = JSON.stringify(JSON.parse(selectedRow?.invoiceFileProcessingMessage), null, 2);
          if (msg) {
            setErrorMessage(msg);
            setIsJson(true);
          }
        } catch {
          setErrorMessage(selectedRow?.invoiceFileProcessingMessage);
        }
      } else {
        setErrorMessage('');
      }
    };
    parseErrorMessage();
  }, [selectedRow?.invoiceFileProcessingMessage]);

  return (
    <StyledModal open={isShowErrorMessage} title='Error Message' subtitle='Description' fullWidth onClose={stopRowAction}>
      <div className='relative'>
        <div className='p-24 border-t border-neutral-20'>
          {isJson ? (
            <pre className='p-12 rounded-8 bg-neutral-10 border border-neutral-40'>{errorMessage}</pre>
          ) : (
            <div className='p-12 rounded-8 bg-neutral-10 border border-neutral-40 font-mono'>{errorMessage}</div>
          )}
        </div>
        <div className='py-16 px-24 border-t border-neutral-20 flex items-center justify-end'>
          <Button variant='neutral_outline' className='!border-2 !min-w-0 !py-6' onClick={() => stopRowAction()}>
            Close
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};
